<template>
  <div class="modal fade" id="policyGlobalModal" @keyup.esc.prevent="closeModal" tabindex="-1" aria-labelledby="policyGlobalModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div v-if="!loaded || !policyId" class="modal-content">
        <div class="modal-header py-0 px-5 justify-content-between">
          <h5 class="modal-title" id="policyGlobalModalLabel">
            <template v-if="policyData">
              <span class="text-gray-600 fw-normal">№</span> {{ policyData.id ?? policyData.global_id}}
            </template>
            <template v-else>Ошибка</template>
          </h5>
          <ul class="nav nav-tabs nav-line-tabs fs-6 ms-auto">
            <li class="nav-item">
              <a class="nav-link py-5 active" data-bs-toggle="tab" href="#main">Основной</a>
            </li>
            <li v-if="policyData.draft" class="nav-item">
              <a class="nav-link py-5" data-bs-toggle="tab" href="#draft">Черновик</a>
            </li>
            <li v-if="policyData.policy" class="nav-item">
              <a class="nav-link py-5" data-bs-toggle="tab" href="#policy">Договор</a>
            </li>
          </ul>
          <button @click="closeModal" type="button" class="btn-close ms-10"></button>
        </div>
        <div class="modal-body p-5" v-if="policyData">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="main" role="tabpanel">
              <policy-info :policy="policyData" />
              <div class="mb-5">
                <div class="row">
                  <div class="col-lg-6">
                    <policy-insurer :insurer="policyData.insurer" />
                    <policy-vehicle v-if="policyData.vehicles && policyData.vehicles.length" :vehicles="policyData.vehicles" />
                    <policy-object v-if="policyData.object" :object="policyData.object" />
                  </div>
                  <div class="col-lg-6">
                    <policy-insured v-if="policyData.insureds && policyData.insureds.length" :insureds="policyData.insureds" />
                    <policy-beneficiary v-if="policyData.beneficiary" :beneficiary="policyData.beneficiary" />
                  </div>
                </div>
              </div>
              <policy-documents v-if="policyData.status === 1 && policyData.error === null && policyData.global_id" :policy="policyData" />
              <h5 v-if="policyData.error" class="text-gray-800 fw-bold mb-3">
                <span class="fw-bold text-danger" v-html="policyData.error_type"></span>
              </h5>
              <div class="p-4 rounded border" v-if="policyData.error">
                <pre class="mb-0" v-html="JSON.stringify(policyData.error, undefined, 1)"></pre>
              </div>
            </div>
            <div v-if="policyData.draft" class="tab-pane fade" id="draft" role="tabpanel">
              <div class="p-4 rounded border" v-if="policyData.draft">
                <json-pretty :data="policyData.draft" :deep="2" showLength showLine/>
              </div>
            </div>
            <div v-if="policyData.policy" class="tab-pane fade" id="policy" role="tabpanel">
              <div class="p-4 rounded border" v-if="policyData.policy">
                <json-pretty :data="policyData.policy" :deep="2" showLength showLine/>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer p-2 justify-content-between">
          <button
              type="button"
              class="btn btn-sm btn-secondary"
              @click="closeModal"
          >Закрыть
          </button>
          <button
              type="button"
              class="btn btn-sm btn-light-primary"
              @click="getFullInfo"
          >Обновить информацию
          </button>
        </div>
      </div>
      <div class="modal-content" v-else>
        <loader-full style="min-height: 323px"/>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import PolicyBeneficiary  from '@/components/Modals/Policy/ModalItems/PolicyBeneficiary'
import PolicyDocuments    from '@/components/Modals/Policy/ModalItems/PolicyDocuments'
import PolicyInsurer      from '@/components/Modals/Policy/ModalItems/PolicyInsurer'
import PolicyInsured      from '@/components/Modals/Policy/ModalItems/PolicyInsured'
import PolicyVehicle      from '@/components/Modals/Policy/ModalItems/PolicyVehicle'
import PolicyObject       from '@/components/Modals/Policy/ModalItems/PolicyObject'
import PolicyInfo         from '@/components/Modals/Policy/ModalItems/PolicyInfo'
import LoaderFull         from '@/components/Main/LoaderFull'
import JsonPretty from 'vue-json-pretty'
import axios              from 'axios'
import 'vue-json-pretty/lib/styles.css'

export default {
  name: 'PolicyGlobalModal',
  components: {
    LoaderFull, PolicyDocuments, PolicyBeneficiary, JsonPretty,
    PolicyInsurer, PolicyInsured, PolicyVehicle, PolicyObject, PolicyInfo
  },
  props: {
    policyId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      policyData: null,
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('policyGlobalModal').addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) this.closeModal()
      });
    }, 10)

  },
  methods: {
    closeModal() {
      bootstrap.Modal.getInstance(document.getElementById('policyGlobalModal')).hide();
      this.$store.commit('setGlobalPolicyModalShow', false);
    },
    getFullInfo() {
      this.loaded = true
      const headers  = {headers: {}, params: {one_c: this.policyId, noPaginate: true}}
      axios.get('/api/policy/all?page=1', headers)
          .then(res  => {
            if (res.data.length > 0) this.policyData = res.data[0]
          })
          .catch(err => { console.log(err) })
          .finally(() => {this.loaded = false})
    },
    toOgpo(isRewrite) {
      this.modalHidden()
      this.$router.push({name: 'Ogpo', query: {global:this.policy.global_id, isRewrite:isRewrite}})
    },
    modalHidden() {
      const myModalEl = document.getElementById('policiesModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
  },
  watch: {
    policyId: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.policyData = newValue
          this.getFullInfo()
        }
      }
    },
  }
}
</script>

<style scoped>

</style>